import { EnderecoFieldGroupModel } from './EnderecoFieldGroup'

export const isEnderecoNaoPreenchido = (e: EnderecoFieldGroupModel): boolean => {
  if (!e) {
    return true
  }
  return (
    !e.bairro?.nome &&
    !e.cep &&
    !e.complemento &&
    !e.logradouro &&
    !e.municipio?.id &&
    !e.numero &&
    !e.pontoReferencia &&
    !e.semNumero &&
    !e.tipoLogradouro?.id &&
    !e.uf?.id
  )
}
